/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(async function () {
  // var $selEle = $("#merged__products .rc_merge_selling_plan, #selling-plan-select");
  $selEle = $(".rc_merge_selling_plan_prepaid");
  var options = await sortSelect($selEle);
  $selEle.html(options);

  var interval = setInterval(function () {
    if ($('[data-section-type="product-single"] .rc-widget').length) {
      console.log("rc found");
      var $el = $('[data-section-type="product-single"] .rc-widget'),
        $html = $("#merged__products").html(),
        $selected = $el.find(".rc-radio__input:checked"),
        val = $selected.val();
      $el.find(".rc_widget__option__plans__dropdown").addClass("hide");
      $el.find(".rc-selling-plans-single").addClass("hide");
      if (val == "onetime") {
        $(".subscriptions__select_wrap").hide();
      } else {
        $(".subscriptions__select_wrap").show();
      }
      $("[data-plans-container], .rc-selling-plans").after($html);
      $("#merged__products").remove();
      var sp_opt = $(".required__subs .rc_merge_selling_plan option")
        .eq(0)
        .attr("value");
      $(".required__subs .rc_merge_selling_plan").val(sp_opt).trigger("change");
      clearInterval(interval);
    }
  }, 100);

  setTimeout(function () {
    clearInterval(interval);
  }, 10000);

  $(document).on(
    "change",
    '[data-section-type="product-single"] .rc-radio__input',
    function () {
      var $el = $(this),
        $wrap = $el.closest("[data-template-legacy-radio]"),
        $selected = $wrap.find(".rc-radio__input:checked"),
        $select_sp = $(".rc_merge_selling_plan"),
        val = $selected.val(),
        s_id = $select_sp.val(),
        $select_default = $('[data-section-type="product-single"] [name="id"]'),
        default_val = $(`[data-section-type="product-single"] .real_variant`)
          .first()
          .attr("value"),
        s_val = $(
          `[data-section-type="product-single"] .merged_variant[data-plan="${s_id}"]`
        ).attr("value");
      if (val == "onetime") {
        $(".subscriptions__select_wrap").hide();
        $select_sp.attr("name", "");
        $select_default.val(default_val);
      } else {
        $(".subscriptions__select_wrap").show();
        $select_sp.attr("name", "selling_plan");
        $select_default.val(s_val);
      }
      setTimeout(function () {
        $(
          '[data-section-type="product-single"] .rc_widget__option__plans__dropdown'
        ).attr("name", "");
      }, 0);
    }
  );


  $(document).on("change", ".rc_merge_selling_plan", function () {
    updateMergedVariant($(this));
  });

  // setTimeout(function () {
  //   $(".rc_merge_selling_plan").each(function () {
  //     updateMergedVariant($(this));
  //   });
  // }, 500);
  initMergedVariant();

}); //ready


// function updateMergedVariant($el) {
//     console.log("callllll");
//     var $select_default = $('[data-section-type="product-single"] [name="id"]'),
//         s_id = $el.val(),
//         s_val = $(
//             `[data-section-type="product-single"] .merged_variant[data-plan="${s_id}"]`
//         ).attr("value");

//     $select_default.val(s_val);
// }


function initMergedVariant() {
  console.log("[Recharge] Started checking for .rc_merge_selling_plan");
  let attempts = 0;
  const maxAttempts = 20;

  const interval = setInterval(function () {
    attempts++;
    console.log(`[Recharge] Attempt #${attempts}`);

    const $elements = $(".rc_merge_selling_plan");

    if ($elements.length) {
      console.log(`[Recharge] Found ${$elements.length} .rc_merge_selling_plan element(s)`);

      $elements.each(function (index) {
        console.log(`[Recharge] Updating element #${index + 1}`, this);
        updateMergedVariant($(this));
      });

      console.log("[Recharge] All elements updated. Clearing interval.");
      clearInterval(interval);
      return;
    }

    console.log("[Recharge] Element not found yet...");

    if (attempts >= maxAttempts) {
      console.warn("[Recharge] Max attempts reached. Stopping interval.");
      clearInterval(interval);
    }
  }, 500);
}

function updateMergedVariant($el) {
    console.log("===== updateMergedVariant =====");
    console.log("$el:", $el);
    console.log("$el.length:", $el.length);

    var $select_default = $('[data-section-type="product-single"] [name="id"]');
    console.log("$select_default:", $select_default);

    var s_id = $el.val();
    console.log("s_id:", s_id);

    var $merged = $(
        `[data-section-type="product-single"] .merged_variant[data-plan="${s_id}"]`
    );

    console.log("$merged:", $merged);
    console.log("$merged.length:", $merged.length);

    var s_val = $merged.attr("value");
    console.log("s_val:", s_val);

    $select_default.val(s_val);

    console.log("Final select value:", $select_default.val());
    console.log("==============================");
}

window.onVariantChange = (variant) => {
  // console.log(variant);
  if (variant) {
    // code
  }
};

jQuery.fn.outerHTML = function (s) {
  return s
    ? this.before(s).remove()
    : jQuery("<p>").append(this.eq(0).clone()).html();
};

async function sortSelect($selElem) {
  let sort_arr = [],
    optionsString = "";
  $selElem.find("option").each(function () {
    let sort_val = $(this).attr("sort");
    sort_arr.push(sort_val);
  });
  sort_arr.sort(function (a, b) {
    return a - b;
  });
  sort_arr.forEach((sortVal) => {
    optionsString += $selElem.find('[sort = "' + sortVal + '"]').outerHTML();
  });
  return optionsString;
}
